'use client';

import {
  Alert,
  Button,
  Divider,
  ItemShape,
  Text
} from '@stone-payments/jade';
import { OrderStatusTracker } from '../orderStatusTracker/orderStatusTracker';
import { FeedbackProps } from './types';

export function Feedback({
  icon = 'check',
  title,
  subtitle,
  amount,
  actionLabel,
  onAction,
  actionDisabled,
  variant = 'success',
  offeredBy,
  orderId,
  statusTracker,
  alert,
}: FeedbackProps) {
  return (
    <div className="w-full rounded-jade-medium bg-jade-background-surface border border-jade-border-low">
      <div className="flex flex-col">
        <div className="flex flex-col items-center gap-3 p-5 border-b border-jade-border-low">
          {statusTracker ? (
            <div className="flex flex-col items-center gap-3 w-full">
              {title && (
                <Text variant="heading-small" className="text-center">
                  {title}
                </Text>
              )}
              <OrderStatusTracker steps={statusTracker} />
            </div>
          ) : (
            <ItemShape
              size="small"
              use={icon as any}
              variant={variant as any}
            />
          )}
          <div className="flex flex-col items-center gap-1 w-full">
            {!statusTracker && title && (
              <Text variant="heading-small" className="text-center">
                {title}
              </Text>
            )}
            {amount && (
              <Text variant="text-large" className="text-center">
                {amount}
              </Text>
            )}

            {subtitle && (
              <Text variant="text-small" color="medium" className="text-center">
                {subtitle}
              </Text>
            )}
          </div>

          {alert && (
            <div className="mt-jade-200">
              <Alert description={alert?.description} variant="negative" />
            </div>
          )}
        </div>
        <Divider direction="horizontal" size="small" />
        {(offeredBy || orderId) && (
          <>
            <div className="flex flex-col items-center gap-1 p-5">
              {offeredBy && (
                <Text
                  variant="text-medium"
                  weight="medium"
                  className="text-center"
                  color="high"
                >
                  {offeredBy}
                </Text>
              )}
              {orderId && (
                <Text
                  variant="text-small"
                  color="medium"
                  className="text-center"
                >
                  {orderId}
                </Text>
              )}
            </div>
          </>
        )}

        {actionLabel && (
          <div className="p-5 pt-1 flex items-center justify-center">
            <Button
              icon="action-download"
              variant="primary-solid"
              size="small"
              onClick={onAction}
              disabled={actionDisabled}
              className="min-w-2"
            >
              {actionLabel}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
